import { useState, useEffect } from 'react';

// 自定义 Hook：useWindowSize
const useWindowSize = () => {
  // 初始化状态，保存窗口的宽度和高度
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 监听窗口大小变化的逻辑
  useEffect(() => {
    // 定义一个处理窗口大小变化的函数
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // 监听窗口的 resize 事件
    window.addEventListener('resize', handleResize);

    // 清理函数：组件卸载时移除事件监听
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // 空依赖数组表示只在组件挂载和卸载时执行

  // 返回窗口的宽度和高度
  return windowSize;
};

export default useWindowSize;
